var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b8b8b8",
    d: "M10.5 0A10.5 10.5 0 1 0 21 10.5 10.531 10.531 0 0 0 10.5 0zm5.25 14.28l-1.47 1.47-3.78-3.78-3.78 3.78-1.47-1.47 3.78-3.78-3.78-3.78 1.47-1.47 3.78 3.78 3.78-3.78 1.47 1.47-3.78 3.78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelButton);
export default __webpack_public_path__ + "static/media/cancel-button.4e6dcdbe3edbb793968d4a2aeb137bca.svg";
export { ForwardRef as ReactComponent };